export default "__VITE_ASSET__1879zYMk__"